@let isEduSite = isEduSite$ | async;
<div
    class="form-group"
    [class.mb-10]="conditionType() !== EDisplayConditionType.ALWAYS"
    [class.mb-0]="conditionType() === EDisplayConditionType.ALWAYS"
>
    <div [class.col-xs-12]="!isCanRemove()" [class.col-xs-10]="isCanRemove()">
        <select class="form-control" (change)="setConditionType($any($event.target).value)">
            @for (option of conditionTypeOptions; track option) {
                <option
                    [selected]="conditionType() === option"
                    [value]="option"
                    [disabled]="
                        (option === EDisplayConditionType.AUTH_EDU && !isEduSite) ||
                        (option === EDisplayConditionType.GROUP_EDU && !isEduSite)
                    "
                >
                    {{ "block_display_condition_type_" + option | translate }}
                </option>
            }
        </select>
    </div>
    @if (isCanRemove()) {
        <div class="col-xs-2">
            <i class="sp-icon icon-bin text-muted" (click)="removeConditionItem()"> </i>
        </div>
    }
    <div class="col-xs-12">
        @if (
            conditionType() === EDisplayConditionType.TIME ||
            conditionType() === EDisplayConditionType.DATE ||
            conditionType() === EDisplayConditionType.WEEKDAY
        ) {
            <p class="help-block small mb-0">
                <span class="sp-icon icon-info-bold color-light"></span>
                {{ "block_display_condition_timezone_hint" | translate }}
            </p>
        }
    </div>
</div>

@if (conditionType() === EDisplayConditionType.URL) {
    <div class="form-group mb-10">
        <div class="col-xs-12">
            <select class="form-control" (change)="setEquality($event)">
                @for (option of equalityOptions; track option) {
                    <option [selected]="equality() === option" [value]="option">
                        {{ "block_display_condition_equality_" + option | translate }}
                    </option>
                }
            </select>
        </div>
    </div>
}

@if (
    conditionType() === EDisplayConditionType.GROUP_EDU ||
    conditionType() === EDisplayConditionType.DATE ||
    conditionType() === EDisplayConditionType.TIME ||
    conditionType() === EDisplayConditionType.WEEKDAY
) {
    <div class="form-group mb-10">
        <div class="col-xs-12">
            <select class="form-control" (change)="setEquality($event)">
                @for (option of equalityTwoOptions; track option) {
                    <option [selected]="equality() === option" [value]="option">
                        {{ "block_display_condition_equality_" + option | translate }}
                    </option>
                }
            </select>
        </div>
    </div>
}

@if (conditionType() === EDisplayConditionType.URL) {
    <div class="form-group mb-0">
        <div class="col-xs-12">
            <input
                class="form-control"
                [value]="value()"
                (blur)="setUrl($event)"
                [placeholder]="'enter_url_placeholder' | translate"
                type="text"
            />
        </div>
    </div>
}

@if (conditionType() === EDisplayConditionType.DATE) {
    <div class="form-group mb-0">
        <div class="col-xs-6 from-date-control">
            <web-date-picker
                class="custom-popover"
                [popoverPos]="'bottom left'"
                [defaultDate]="defaultStartDate()"
                (dateChange)="setStartDate($event)"
            />
        </div>
        <div class="col-xs-6">
            <web-date-picker
                class="custom-popover"
                [minDate]="defaultStartDate()"
                [popoverPos]="'bottom right'"
                [defaultDate]="defaultEndDate()"
                (dateChange)="setEndDate($event)"
            />
        </div>
    </div>
}

@if (conditionType() === EDisplayConditionType.TIME) {
    <div class="form-group mb-0">
        <div class="col-xs-6 from-time-control">
            <web-time-picker [defaultTime]="toDate(startTime())" (timeChange)="setStartTime($event)" />
        </div>
        <div class="col-xs-6">
            <web-time-picker [defaultTime]="toDate(endTime())" (timeChange)="setEndTime($event)" />
        </div>
    </div>
}

@if (conditionType() === EDisplayConditionType.AUTH_EDU) {
    <div class="form-group mb-0">
        <div class="col-xs-12">
            <select class="form-control" (change)="setAuthEduValue($event)">
                @for (option of authEduOptions; track option) {
                    <option [selected]="value() === option" [value]="option">
                        {{ "block_display_condition_auth_edu_state_" + option | translate }}
                    </option>
                }
            </select>
        </div>
    </div>
}

@if (conditionType() === EDisplayConditionType.GROUP_EDU) {
    <div class="form-group mb-0">
        @let eduCourses = eduCourses$ | async;
        @if (eduCourses?.length) {
            <div class="col-xs-12">
                <ng-select
                    class="sp-ng-select"
                    [items]="eduCourses"
                    bindLabel="name"
                    [groupBy]="'courseName'"
                    [clearable]="false"
                    [searchable]="false"
                    appendTo="body"
                    [ngModel]="value()?.groupName"
                    (ngModelChange)="setEduGroupValue($event)"
                >
                    <ng-template ng-optgroup-tmp let-item="item">
                        {{ item.courseName }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        {{ item.name }}
                    </ng-template>
                </ng-select>
            </div>
        } @else {
            <div class="col-xs-12">
                <p class="help-block">{{ "courses_have_no_groups_hint" | translate }}</p>
            </div>
        }
    </div>
}

@if (conditionType() === EDisplayConditionType.WEEKDAY) {
    <div class="form-group mb-0">
        <div class="col-xs-12">
            <select class="form-control" (change)="setWeekdayValue($event)">
                <option [selected]="value()?.dayCount === 1">{{ "monday" | translate }}</option>
                <option [selected]="value()?.dayCount === 2">{{ "tuesday" | translate }}</option>
                <option [selected]="value()?.dayCount === 3">{{ "wednesday" | translate }}</option>
                <option [selected]="value()?.dayCount === 4">{{ "thursday" | translate }}</option>
                <option [selected]="value()?.dayCount === 5">{{ "friday" | translate }}</option>
                <option [selected]="value()?.dayCount === 6">{{ "saturday" | translate }}</option>
                <option [selected]="value()?.dayCount === 0">{{ "sunday" | translate }}</option>
            </select>
        </div>
    </div>
}
